<template>
  <div class="kws-int-container">
    <introduction
      v-if="step === 0"
      :fsCcAttrs="introduction.fsCcAttrs"
      :headline="introduction.headline"
      :text="introduction.text"
      :img="introduction.img"
      @start="goOn"
    ></introduction>
    <question
      v-if="step > 0 && questions"
      :step="step"
      :id="questions[step - 1].id"
      :key="questions[step - 1].fsCcAttrs"
      :fsCcAttrs="questions[step - 1].fsCcAttrs"
      :total="questions.length"
      :text="questions[step - 1].text"
      :img="questions[step - 1].img"
      :answers="questions[step - 1].answers"
      :first="!introduction"
      :last="step === questions.length"
      @go-back="goBack"
      @go-on="goOn"
      @evaluate-result="evaluateResult"
    ></question>
  </div>
</template>

<script>
import Introduction from './introduction.vue';
import Question from './question.vue';

export default {
  components: {
    Introduction,
    Question,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    introduction: Object,
    questions: Array,
    result: Object,
  },
  data: () => ({
    step: 0,
  }),
  methods: {
    goBack() {
      this.step -= 1;
    },
    goOn() {
      this.step += 1;
    },
    evaluateResult() {
      const answerCombination = this.getCommaSeperatedAnswers();
      const redirect = (!(answerCombination in this.result.redirects))
        ? this.result.redirects.default
        : this.result.redirects[answerCombination];
      this.redirectTo(redirect);
    },
    getCommaSeperatedAnswers() {
      return (this.questions.reduce(
        (previousQuestion, question) => `${previousQuestion}${question.answers.options.filter((o) => o.selected).reduce(
          (previousAnswer, answer) => `${previousAnswer}${answer.id},`,
          '',
        )}`,
        '',
      )).replace(/,+$/g, ''); // trim last comma
    },
    redirectTo(redirect) {
      const link = document.createElement('a');
      link.href = redirect.href;
      if ('target' in redirect) {
        link.target = redirect.target;
      }
      link.click();
    },
  },
  created() {
    if (!this.introduction) {
      this.step = 1;
    }
  },
};
</script>
